// =========================================================================
// The Ledger on a cable, from the dashboard — the signing page's own code,
// re-exported, never copied.
//
// The operator asked for the signer in the app itself (17 Oct 2026): sign a
// card on the Ledger over USB from Approvals, register the Ledger's account
// key from Devices & keys, no separate page needed. The page stays for a
// phone. What the dashboard runs for that is the page's modules, byte for
// byte: cosign/src/ledger.ts speaks to the device (WebHID, the TRON app's
// three commands), cosign/src/verify.ts decodes and checks a card. A second
// implementation in this bundle would be a second place for the one kind of
// bug that moves money, so there is none — this file is the import path and
// nothing else, and the build proves the bundler and the type-checker accept
// the two modules from outside the app's root (tsconfig.json include).
//
// WebHID is Chromium-only: Brave or Edge on the Mac (he dislikes Chrome; any
// Chromium is fine). Where `webHid()` is null the screens fall back to the
// signing link and its QR code, as before. Ledger Live must be closed while a
// browser signs — the device answers one program at a time.
// =========================================================================

export * from '../../../cosign/src/ledger';
export * from '../../../cosign/src/verify';

import { networkOf, type Network } from '../../../cosign/src/verify';

/**
 * The TRON network this build signs for — the same setting the signing page
 * reads (VITE_ENVIRONMENT: 'production' = mainnet, 'nile' = the test
 * network), so a dashboard built for the test network refuses a mainnet card
 * the way the page does, and the other way round. Not declared in
 * vite-env.d.ts: read the page's way, and 'production' when unset — a build
 * that says nothing is a mainnet build, never a test one by accident.
 */
export function buildEnvironment(): string {
  return (import.meta as { env?: Record<string, string | undefined> }).env?.VITE_ENVIRONMENT ?? 'production';
}

/** The network word for this build, or null when its setting names none (and the cable signer refuses). */
export function buildNetwork(): Network | null {
  return networkOf(buildEnvironment());
}
